import React from 'react';
import { Ban, Clock, FileText, Home, Phone, RefreshCcw, ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
type Kind = 'cancelled' | 'superseded' | 'review';
const config: Record<Kind, {
  color: string;
  bg: string;
  icon: typeof Ban;
  title: string;
  caseNo: string;
  docId: string;
  status: string;
  updated: string;
  instruction: string;
}> = {
  cancelled: {
    color: '#D93036',
    bg: '#FCE9EA',
    icon: Ban,
    title: 'নোটিশটি বাতিল করা হয়েছে',
    caseNo: 'DMP/AI/2025/0612/0651',
    docId: 'DMP-DOC-2025-0651-V1',
    status: 'বাতিল',
    updated: '২০/০৬/২০২৫',
    instruction: 'এই নোটিশের ভিত্তিতে কোনো কার্যক্রম গ্রহণের প্রয়োজন নেই। কোনো ব্যক্তি এই নোটিশের ভিত্তিতে অর্থ দাবি করলে অবিলম্বে রিপোর্ট করুন।'
  },
  superseded: {
    color: '#1769AA',
    bg: '#E8F1FA',
    icon: RefreshCcw,
    title: 'এই নোটিশের পরিবর্তে নতুন সংস্করণ ইস্যু করা হয়েছে',
    caseNo: 'DMP/AI/2025/0612/0644',
    docId: 'DMP-DOC-2025-0644-V1',
    status: 'নতুন সংস্করণ দ্বারা প্রতিস্থাপিত',
    updated: '১৮/০৬/২০২৫',
    instruction: 'নতুন সংস্করণ (DMP-DOC-2025-0644-V2) এর তথ্য অনুসরণ করুন। নতুন নোটিশ ডাকযোগে পাঠানো হয়েছে; নিচের বোতাম থেকে অফিসিয়াল কপি দেখুন।'
  },
  review: {
    color: '#E69A20',
    bg: '#FDF3E2',
    icon: Clock,
    title: 'নোটিশটি বর্তমানে পর্যালোচনাধীন',
    caseNo: 'DMP/AI/2025/0614/0752',
    docId: 'DMP-DOC-2025-0752-V1',
    status: 'পর্যালোচনাধীন',
    updated: '১৫/০৬/২০২৫',
    instruction: 'নোটিশের তথ্য ডিএমপি কর্তৃক পর্যালোচনা করা হচ্ছে। পর্যালোচনা শেষে হালনাগাদ অবস্থা এই পোর্টালে দেখা যাবে। প্রয়োজনে সংশ্লিষ্ট ট্রাফিক বিভাগে যোগাযোগ করুন।'
  }
};
export function NoticeStateResult({
  kind
}: {
  kind: Kind;
}) {
  const navigate = useNavigate();
  const c = config[kind];
  const Icon = c.icon;
  return <div className="mx-auto max-w-2xl px-4 py-8" data-id="element-2042" data-mp="3ssgpx61dzr7b">
      <div className="overflow-hidden rounded-xl border-2 bg-white" style={{
      borderColor: c.color
    }} data-id="element-2043" data-mp="3ns2gpko1ub7p">
        <div className="flex items-center gap-4 px-5 py-5 text-white" style={{
        backgroundColor: c.color
      }} data-id="element-2044" data-mp="3p97vqznt07qd">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-2045" data-mp="3u8kqs7otwl41"><Icon className="h-8 w-8" style={{
            color: c.color
          }} data-id="element-2046" data-mp="3g8jnymp073lx" /></span>
          <div className="text-lg font-bold leading-snug md:text-xl" data-id="element-2047" data-mp="3gamed7u2iyr6">{c.title}</div>
        </div>
        <dl className="divide-y divide-border" data-id="element-2048" data-mp="3l9h46tqgdnks">
          {[['মামলা রেফারেন্স', c.caseNo], ['Document ID', c.docId], ['বর্তমান অবস্থা', c.status], ['সর্বশেষ হালনাগাদ', c.updated]].map(([k, v]) => <div key={k} className="grid grid-cols-[150px_1fr] gap-3 px-5 py-3" data-id="element-2049" data-mp="3bb1fsyit8sez">
              <dt className="text-sm text-slate-500" data-id="element-2050" data-mp="2xjmugl1fkf4r">{k}</dt>
              <dd className={`font-semibold ${k === 'Document ID' || k === 'মামলা রেফারেন্স' ? 'font-mono text-[13.5px]' : ''}`} style={k === 'বর্তমান অবস্থা' ? {
            color: c.color
          } : undefined} data-id="element-2051" data-mp="31ilzs6r2qdwq">{v}</dd>
            </div>)}
        </dl>
        <div className="m-5 rounded-lg p-4 text-[15px]" style={{
        backgroundColor: c.bg
      }} data-id="element-2052" data-mp="2shxm5d5lefkd">
          <div className="mb-1 font-semibold" data-id="element-2053" data-mp="28x5posh64x6y">পরবর্তী নির্দেশনা</div>
          {c.instruction}
        </div>
        {kind === 'review' && <div className="mx-5 mb-5 flex items-start gap-2 text-sm text-slate-600" data-id="element-2054" data-mp="2iutmdnyc4err">
            <Phone className="mt-0.5 h-4 w-4" data-id="element-2055" data-mp="2dw05rmnr47nd" /> যোগাযোগ: উপ-পুলিশ কমিশনার (ট্রাফিক-গুলশান) কার্যালয়, অফিস চলাকালীন সময়ে। জরুরি প্রয়োজনে ৯৯৯।
          </div>}
      </div>
      <div className="mt-5 grid gap-3 sm:grid-cols-3" data-id="element-2056" data-mp="2rtoq8tdwpcrw">
        {kind === 'superseded' && <Button className="h-12" onClick={() => navigate('/citizen/notice')} data-id="element-2057" data-mp="2mw5bzth7kzzy"><FileText className="h-4 w-4" data-id="element-2058" data-mp="31lugnyoifm4z" /> নতুন সংস্করণ দেখুন</Button>}
        <Button variant="outline" className="h-12" onClick={() => navigate('/citizen')} data-id="element-2059" data-mp="2wmhuzh9dkl3z"><Home className="h-4 w-4" data-id="element-2060" data-mp="2wokv4u48rumf" /> হোমে ফিরে যান</Button>
        <Button variant="outline" className="h-12 border-[#D93036]/40 text-[#D93036] hover:bg-[#FCE9EA]" onClick={() => navigate('/citizen/report')} data-id="element-2061" data-mp="3anat0byvxybu"><ShieldAlert className="h-4 w-4" data-id="element-2062" data-mp="36ikxio852lrg" /> রিপোর্ট করুন</Button>
      </div>
    </div>;
}